import {SUPPORT_REQUESTS} from './supportTextReducer'

export const GetSupportText = () =>{
  return{
    type:SUPPORT_REQUESTS.SUPPORT_REQUEST_REQUEST,
  }
}